import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

type Props = {
    titleKey: string;
    descriptionKey: string;
};

const CrmEnrichmentJobWizardHeader = ({ titleKey, descriptionKey }: Props) => {
    const translate = useTranslation();

    return (
        <Stack gap="8px">
            <Text
                fontVariant="h4"
                color={colorsPalettes.carbon[500]}
            >
                {translate(titleKey)}
            </Text>

            <Text
                fontVariant="body1"
                color={colorsPalettes.carbon[400]}
            >
                {translate(descriptionKey)}
            </Text>
        </Stack>
    );
};

export default CrmEnrichmentJobWizardHeader;
